export default __webpack_public_path__ + "static/media/result_2.fcea72e8.jpg";